"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QSRCircularColor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const KImage_1 = require("../KImage");
var QSRCircularColor;
(function (QSRCircularColor) {
    QSRCircularColor["PRIMARY"] = "primary";
    QSRCircularColor["SECONDARY"] = "secondary";
    QSRCircularColor["SUCCESS"] = "success";
    QSRCircularColor["FAILED"] = "failed";
})(QSRCircularColor || (exports.QSRCircularColor = QSRCircularColor = {}));
const QSRCircular = (_a) => {
    var props = __rest(_a, []);
    const theme = (0, material_1.useTheme)();
    const thickness = props.thickness || 3;
    const size = props.size || 180;
    const { containerOverrides, imgOverrides } = props;
    const status = {
        primary: { color: theme.palette.primary.main, shadow: theme.qlub.palette.circular.main },
        secondary: { color: theme.qlub.palette.onSurfaceColors.disabled, shadow: theme.qlub.palette.dim.main },
        success: { color: theme.qlub.palette.success.main, shadow: theme.qlub.palette.success.main },
        failed: { color: theme.qlub.palette.danger.main, shadow: theme.qlub.palette.danger.transparent },
    };
    const selectedColor = status[props.activeStatus] || status.secondary;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: (0, merge_1.merge)(true, { position: 'relative', display: 'inline-flex' }, containerOverrides), children: [(0, jsx_runtime_1.jsx)(material_1.CircularProgress, Object.assign({ variant: "determinate" }, props, { size: size, thickness: thickness, sx: {
                    borderRadius: '50%',
                    boxShadow: `0px 0px 0px ${thickness * 4}px ${selectedColor.shadow} inset`,
                    backgroundColor: 'transparent',
                    strokeLinecap: ' round',
                    zIndex: '1',
                    color: `${selectedColor.color}`,
                } })), props.timeCount && !['00:00', '0:00', '0:0', '0'].includes(props.timeCount) && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    top: -5,
                    width: '100%',
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    zIndex: '2',
                }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '4px 16px',
                        height: 34,
                        backgroundColor: theme.qlub.palette.white.main,
                        borderRadius: '100px',
                        color: `${selectedColor.color}`,
                        zIndex: '2',
                        fontSize: '16px',
                        fontWeight: 500,
                        fontFamily: 'inherit',
                    }, children: props.timeCount }) })), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, children: props.imgSrc && ((0, jsx_runtime_1.jsx)(KImage_1.default, { src: props.imgSrc, alt: "circular", style: (0, merge_1.merge)(true, {
                        objectFit: 'contain',
                        width: size / 1.3,
                        height: size / 1.3,
                        borderRadius: '50%',
                    }, imgOverrides) })) })] }));
};
exports.default = QSRCircular;
